export default {
	data: function () {
		return {
			theme: {
				transitions: {
					cubic:					'cubic-bezier(.25, .8, .25, 1)'
				},
				typography: {
					h1:	{
						fontFamily:			'Montserrat',
						fontWeight:			'100',
						fontSize:			'96px',
						letterSpacing:		'-1.5px'
					},
					h2:	{
						fontFamily:			'Montserrat',
						fontWeight:			'100',
						fontSize:			'60px',
						letterSpacing:		'-0.5px'
					},
					h3:	{
						fontFamily:			'Montserrat',
						fontWeight:			'300',
						fontSize:			'48px'
					},
					h4:	{
						fontFamily:			'Montserrat',
						fontWeight:			'300',
						fontSize:			'34px',
						letterSpacing:		'0.25px'
					},
					h5:	{
						fontFamily:			'Montserrat',
						fontWeight:			'300',
						fontSize:			'24px'	
					},
					h6:	{
						fontFamily:			'Montserrat',
						fontWeight:			'400',
						fontSize:			'20px',
						letterSpacing:		'0.15px'
					},
					subtitle1:	{
						fontFamily:			'Montserrat',
						fontWeight:			'300',
						fontSize:			'16px',
						letterSpacing:		'0.15px'	
					},
					subtitle2:	{
						fontFamily:			'Montserrat',
						fontWeight:			'400',
						fontSize:			'14px',
						letterSpacing:		'0.1px'
					},
					body1:	{
						fontFamily:			'Montserrat',
						fontWeight:			'300',
						fontSize:			'16px',
						letterSpacing:		'0.5px'
					},
					body2:	{
						fontFamily:			'Montserrat',
						fontWeight:			'300',
						fontSize:			'14px',
						letterSpacing:		'0.25px'
					},
					button:	{
						fontFamily:			'Montserrat',
						fontWeight:			'100',
						fontSize:			'14px',
						textTransform:		'uppercase'
					},
					caption:	{
						fontFamily:			'Montserrat',
						fontWeight:			'300',
						fontSize:			'12px',
						letterSpacing:		'0.4px'
					},
					overline:	{
						fontFamily:			'Montserrat',
						fontWeight:			'300',
						fontSize:			'10px',
						textTransform:		'uppercase',
						letterSpacing:		'1.5px'
					}
				},
				colors: {
					primary: 				'#61ce70',
					disabledPrimary:		'#cccccc',
					onPrimary: 				'#ffffff',
		
					primaryVariant: 		'#4b9c56',
					disabledPrimaryVariant:	'#cccccc',
					onPrimaryVariant:		'#ffffff',
		
					secondary:				'#249b23',
					onSecondary:			'#ffffff',
					
					secondaryVariant:		'#8bc349',
					onSecondaryVariant:		'#ffffff',
	
					background:				'#f7f7f7',
					backgroundShadow:		'#d2d2d2',
					onBackground:			'#000000',
					onBackgroundVariant:	'#989898',

					backgroundVariant:		'#F5F5F5',
	
					surface:				'#ffffff',
					onSurface:				'#000000',
					onSurfaceVariant:		'#989898',
	
					info:					'#04a9f3',
					onInfo:					'#ffffff',
	
					success:				'#249b23',
					onSuccess:				'#ffffff',
	
					warning:				'#ffc107',
					onWarning:				'#ffffff',
	
					error:					'#e51c22',
					onError:				'#ffffff'
				}
			}
		};
	}
};